import { createContext, useContext } from 'react';
export var FlagContext = createContext({
    variation: function (flagName, defaultValue) { return defaultValue; },
});
export var useFlagContextValue = function () {
    var context = useContext(FlagContext);
    return context;
};
//# sourceMappingURL=FlagContext.js.map